import React from 'react';

const PlaceholderPage = ({ title, description }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-soft-cream/30">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <span className="material-symbols-outlined text-primary text-6xl mb-6 block">construction</span>
        <h1 className="text-4xl font-bold text-charcoal mb-4">{title}</h1>
        <p className="text-lg text-muted-gold mb-8">{description}</p>
        <div className="bg-white p-6 rounded-lg shadow-lg border border-soft-cream">
          <p className="text-sm text-muted-gold">
            Questa pagina è attualmente in sviluppo e sarà disponibile nelle prossime fasi.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderPage;
